import { IACCNofiticationVm } from "../../../model/request/nofitication/IAccNofitication";
import { INofiticationRequest } from "../../../model/request/nofitication/INofiticationRequest";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface INotificationLoadResult {
  items: IACCNofiticationVm[];
  total_count: number;
  unread_count: number;
  // append = tải thêm (nối tiếp danh sách); false/undefined = tải mới (thay thế).
  append?: boolean;
}

export const eNotificationActionsObj = {
  CHANGE_REQUEST: {} as any,

  LOAD_START: {} as INofiticationRequest & { append?: boolean },
  LOAD_SUCCESS: {} as INotificationLoadResult,
  LOAD_ERRR: "",

  // Chỉ lấy số chưa đọc (badge) — không mở popup.
  LOAD_UNREAD_COUNT_START: undefined as void | undefined,
  LOAD_UNREAD_COUNT_SUCCESS: 0 as number,

  MARK_READ_START: 0 as number, // id thông báo (0 = tất cả)
  MARK_READ_SUCCESS: 0 as number,

  // Cập nhật trạng thái xử lý 1 thông báo (da_xu_ly / bo_qua) sau khi xử lý xong.
  SET_TRANG_THAI: {} as { id: number; trang_thai: string },

  CHANGE_SHOW: false,
  CHANGE_READ_STATUS: "" as "all" | "unread",
};
export const eNotificationActionIds = generateActionTypeIds(
  eNotificationActionsObj,
  "NOFITICATION",
);
export type INotificationActionTypes = IGenericActionType<
  typeof eNotificationActionsObj,
  "NOFITICATION"
>;
